<template>
    <div id="wrapper" class="page" v-if="salary_read">
      <div id="content-wrapper">
        <div class="container-fluid">
          <span style="display: inline;">
            <!-- <button class="btn btn-success mb-2 mr-2" @click.prevent="excelReport">
              <i class="far fa-file-excel"></i> Xuất excel
            </button> -->
            <b-row>
              <b-col>
                <b-form-select v-model="year_selected" class="mb-2 mr-2" style="width: 10%" :options="optionsYear" value-field="value" text-field="text" @change="updateData"/>
                <b-form-select  v-model="month_selected" class="mb-2 mr-2" style="width: 10%" :options="optionsMonth" value-field="value" text-field="text" @change="updateData"/>
                <h style="color:red;" v-if="!is_all_department && !leavelocked"><b>
                  Timekeeping is not locked
                  <!-- CHẤM CÔNG CHƯA KHÓA -->
                </b></h>
                <button v-if="leavelocked && !islocked" class="btn btn-outline-success mb-2 mr-2" type="button" @click.prevent="changeLock">
                  <i class="fas fa-lock" style="color:green"></i>
                  Lock timekeeping & confirm salary
                  <!-- Khóa chấm công và tính lương -->
                </button>
                <button v-if="islocked && !finalizelocked" class="btn btn-outline-dark mb-2 mr-2" type="button" @click.prevent="changeLock">
                  <i class="fas fa-unlock-alt"></i>
                  Unlock timekeeping
                  <!-- Mở khóa chấm công -->
                </button>
                <button v-if="islocked && !finalizelocked" class="btn btn-outline-danger mb-2 mr-2" type="button" @click.prevent="finalizeLock">
                  <i class="fas fa-lock" style="color:red"></i>
                  Confirm
                  <!-- Chốt -->
                </button>
                <button v-if="finalizelocked" class="btn btn-outline-dark mb-2 mr-2" type="button" @click.prevent="finalizeLock">
                  <i class="fas fa-unlock-alt"></i>
                  Unlock
                  <!-- Mở -->
                </button>
                <h style="color:red;" v-if="finalizelocked"><b>
                  LOCKED MONTH
                  <!-- THÁNG ĐÃ CHỐT -->
                </b></h>
                <!-- <label style="float: right;">Ngày công chuẩn</label> -->
                 <b-form-group
                    label = "Standard Work day:"
                    style="font-weight: bold;float: right;"
                    label-cols-sm="10"
                    label-align-sm="right">
                   <b-form-input v-model="ngaycongchuan" readonly/>
                </b-form-group>
              </b-col>
            </b-row>
            <!-- <button style="float: right;" class="btn btn-outline-dark mb-2 mr-2" type="button" @click.prevent="sendEmail">
              Gửi email
            </button> -->

            <!-- <h class="mr-2" style="font-size:20px;float: right;"><b>Ngày công chuẩn:</b></h> -->
           <b-row>
              <b-col>
                <b-form-input class="mb-2" v-model="query"
                      placeholder="Filter by employee code, name"
                      @keydown.enter.prevent="queryItem"
                    ></b-form-input>
              </b-col>
            </b-row>
          </span>
          <b-table
          bordered
          head-variant="dark"
          hover
          responsive
          striped
          small
          table-variant="light"
          :fields="salaryFields"
          :items="salaries"
          >
            <template #cell(tongluong)="data">{{data.item.tongluong | numeral('0,0')}}</template>
            <template #cell(luongtheongaycong)="data">{{data.item.luongtheongaycong | numeral('0,0')}}</template>
            <template #cell(luongthucnhan)="data">{{data.item.luongthucnhan | numeral('0,0')}}</template>
            <template #cell(bonus)="data">{{data.item.bonus | numeral('0,0')}}</template>
            <!-- <template #cell(thunhapkhac)="data">
              <b-form-input autocomplete="off" type="number" style="text-align: right;" :value="data.item.thunhapkhac" @change="updateThunhapkhac(data, $event)" :disabled="finalizelocked"/>
            </template> -->
            <template #cell(thunhapkhac)="data">
              <span>
              <my-currency-input-salaries v-model="data.item.thunhapkhac" :data="data" @change="updateThunhapkhac(data, $event)" :locked="finalizelocked" :salaries="salaries" @updateThunhapkhac="updateSalaries"></my-currency-input-salaries>
              </span>
            </template>
            <template #cell(ghichu)="data">
              <b-form-input autocomplete="off" :value="data.item.ghichu" @change="updateGhichu(data, $event)" :disabled="finalizelocked"/>
            </template>
            <template slot="bottom-row">
              <td style="text-align:center" colspan="4"><b>TỔNG</b></td>
              <td style="text-align:right"><b>{{sum_tong_luong | numeral('0,0')}}</b></td>
              <td style="text-align:right"><b>{{sum_luong_theo_ngay_cong | numeral('0,0')}}</b></td>
              <td style="text-align:right"><b>{{sum_bonus | numeral('0,0')}}</b></td>
              <td style="text-align:right"><b>{{sum_thu_nhap_khac | numeral('0,0')}}</b></td>
              <td style="text-align:right"><b>{{sum_luong_thuc_nhan | numeral('0,0')}}</b></td>
            </template>
          </b-table>
        </div>
      </div>
    </div>
</template>

<script>
import axios from "axios";
// import MyCurrencyInputSalaries from "../components/App/MyCurrencyInputSalaries";
import MyCurrencyInputSalaries from '../components/App/MyCurrencyInputSalaries.vue';

export default {
  name: "Salaries",
  components: {
    MyCurrencyInputSalaries,
  },
  data() {
    return {
      salaryFields :[
        {
          key: "manhanvien",
          label: "Code",
          // label: "Mã NV",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "hovaten",
          label: "Name",
          // label: "Tên",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "vitricongviec",
          label: "Position",
          // label: "Chức vụ",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "ngaycong",
          label: "Work day",
          // label: "Ngày công",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "tongluong",
          label: "Total salary",
          // label: "Tổng lương",
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "luongtheongaycong",
          label: "Salary based on work day",
          // label: "Lương theo ngày công",
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "bonus",
          label: "Bonus",
          // label: "Lương theo ngày công",
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "thunhapkhac",
          label: "Other income PIT",
          // label: "Thu nhập khác",
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "luongthucnhan",
          label: "Net salary",
          // label: "Lương thực nhận",
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
        {
          key: "ghichu",
          label: "Note",
          // label: "Ghi chú",
          tdClass: "text-right",
          thClass: "align-middle",
          thStyle: { textAlign: "center" },
        },
      ],
      query: null,
      salaries: [],
      year_selected: 0,
      month_selected: 0,
      islocked: false,
      leavelocked: false,
      finalizelocked: false,
      ngaycongchuan: 0,
      optionsMonth: [ {value: 1, text: "January"},
                      {value: 2, text: "February"},
                      {value: 3, text: "March"},
                      {value: 4, text: "April"},
                      {value: 5, text: "May"},
                      {value: 6, text: "June"},
                      {value: 7, text: "July"},
                      {value: 8, text: "August"},
                      {value: 9, text: "September"},
                      {value: 10, text: "October"},
                      {value: 11, text: "November"},
                      {value: 12, text: "December"},],
                      // optionsMonth: [ {value: 1, text: "Tháng 1"},
                      // {value: 2, text: "Tháng 2"},
                      // {value: 3, text: "Tháng 3"},
                      // {value: 4, text: "Tháng 4"},
                      // {value: 5, text: "Tháng 5"},
                      // {value: 6, text: "Tháng 6"},
                      // {value: 7, text: "Tháng 7"},
                      // {value: 8, text: "Tháng 8"},
                      // {value: 9, text: "Tháng 9"},
                      // {value: 10, text: "Tháng 10"},
                      // {value: 11, text: "Tháng 11"},
                      // {value: 12, text: "Tháng 12"},],
    }
  },
  computed: {
    salary_read() {
      return this.$store.getters.hasPermission("salary_read");
    },
    optionsYear() {
      var result = [];
      var this_year = new Date().getFullYear();
      for (var i = 2020; i <= this_year; ++i) {result.push({value: i, text: i});}
      return result;
    },
    is_all_department() {
      return this.$store.state.auth.departmentId == 0;
    },
    sum_luong_thuc_nhan() {
      var sum = 0;
      for (var item of this.salaries) {sum += item.luongthucnhan;}
      return sum;
    },
    sum_tong_luong() {
      var sum = 0;
      for (var item of this.salaries) {sum += item.tongluong;}
      return sum;
    },
    sum_bonus() {
      var sum = 0;
      for (var item of this.salaries) {sum += item.bonus;}
      return sum;
    },
    sum_luong_theo_ngay_cong() {
      var sum = 0;
      for (var item of this.salaries) {sum += item.luongtheongaycong;}
      return sum;
    },
    sum_thu_nhap_khac() {
      var sum = 0;
      for (var item of this.salaries) {sum += item.thunhapkhac;}
      return sum;
    },
    // thunhapkhac() {
    //   return this.salaries.map(salaries => salaries.thunhapkhac)
    // },
  },
  beforeRouteEnter(to, from, next) {
      axios
      .all([
          axios.get(`/api/salary`),
          axios.get("/api/salary/lock"),
          axios.get("/api/leaveschedule/lock"),
          axios.get("/api/salary/finalizelock"),
      ])
      .then(
          axios.spread((salary, islocked,  leavelocked, finalizelocked )=> {
              next((vm) => vm.initData(salary.data, islocked.data, leavelocked.data, finalizelocked.data));
          })
      );
  },
  // watch: {
  //   thunhapkhac(newValue) {
  //     this.$toast.error("Vui lòng nhập tên! " + newValue, "Lỗi", { timeout: 3000 });
  //   },
  // },
  methods:{
    initData(salaries, islocked, leavelocked, finalizelocked) {
      this.salaries = salaries;
      this.islocked = islocked;
      this.leavelocked = leavelocked;
      this.finalizelocked = finalizelocked;
      this.ngaycongchuan = (this.salaries.length > 0) ? this.salaries[0].ngaycongchuan : 0;

      this.year_selected = new Date().getFullYear();
      this.month_selected = parseInt(new Date().getMonth() + 1);
    },
    excelReport() {
      let query = Object.assign({}, this.$route.query);
      query.year = this.year_selected;
      query.month = this.month_selected;
      axios({
        method: "get",
        url: `/api/salary/report`,
        params: query,
        responseType: "blob", // important
      })
        .then((res) => {
          let filename = res.headers["content-disposition"]
            .split(";")
            .find(function(el) {
              if (el.includes("filename=")) return el;
            })
            .replace("filename=", "")
            .trim();
          const url = window.URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.ms-excel;charset=utf-8",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          //   reject(err);
        });
    },
    updateData() {
      let query = Object.assign({}, this.$route.query);
      query.year = this.year_selected;
      query.month = this.month_selected;
      query.deptid = this.$store.state.auth.departmentId;

      axios
      .all([
          axios.get(`/api/salary`, {params: query}),
          axios.get("/api/salary/lock", {params: query}),
          axios.get("/api/leaveschedule/lock", {params: query}),
          axios.get("/api/salary/finalizelock", {params: query})
      ])
      .then(
          axios.spread((salary, islocked, leavelocked, finalizelocked) => {
              this.salaries = salary.data;
              this.islocked = islocked.data;
              this.leavelocked = leavelocked.data;
              this.finalizelocked = finalizelocked.data;

              this.ngaycongchuan = (this.salaries.length > 0) ? this.salaries[0].ngaycongchuan : 0;
          })
      );

      axios.get("/api/salary", {params: query})
      .then((res) => {this.salaries = res.data;});
    },
    changeLock() {
      axios.post("/api/salary/lock?islocked=" + this.islocked +"&year=" + this.year_selected + "&month=" + this.month_selected + "&deptid=" + this.$store.state.auth.departmentId)
      .then((res) => {
        this.islocked = res.data;
        if (!this.islocked) this.salaries = [];
        else this.updateData();
      })
      .catch((err) => {this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });})
    },
    finalizeLock() {
      axios.post("/api/salary/finalizelock?islocked=" + this.finalizelocked +"&year=" + this.year_selected + "&month=" + this.month_selected + "&deptid=" + this.$store.state.auth.departmentId)
      .then((res) => {this.finalizelocked = res.data;})
      .catch((err) => {this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });})
    },

    sendEmail() {
      axios.post("/api/salary/test")
      .then();
      // .catch((err) => {this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 });
      // })
    },

    queryItem() {
      let query = Object.assign({}, this.$route.query);
      query.q = this.query;
      query.year = this.year_selected;
      query.month = this.month_selected;

      axios.get("/api/salary", {params: query})
      .then((res) => {this.salaries = res.data});
    },
    // @Edit Thanh Chuyen event sang myCurrencyInputSalaries
    // updateThunhapkhac(data, event) {
    //   var payload = Object.assign({}, data.item);

    //   if (event != "") payload.thunhapkhac = parseFloat(event);
    //   else payload.thunhapkhac = 0;

    //   axios.put("/api/salary", payload)
    //   .then((res) => {
    //     this.$toast.success("Cập nhật thành công !", "Thành công", {timeout: 3000,});
    //     this.salaries[data.index].luongthucnhan = res.data.luongthucnhan;
    //     this.salaries[data.index].thunhapkhac = res.data.thunhapkhac;
    //   })
    //   .catch((err) => {this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 })})
    // },
    updateGhichu(data, event) {
      var payload = Object.assign({}, data.item);
      payload.ghichu = event;
      axios.put("/api/salary", payload)
      .then((res) => {this.$toast.success("Cập nhật thành công !", "Thành công", {timeout: 3000,});})
      .catch((err) => {this.$toast.error(err.response.data, "Lỗi", { timeout: 3000 })})
    },
    updateSalaries(data) {
      this.salaries = data;
    }
  },
}
</script>
